import { createContext } from 'react'

import { INotificationContext } from './types'

const context: INotificationContext = {
  notification: {
    open: false,
    title: 'info',
    message: '',
    variant: 'info',
    autoHide: true
  },
  setNotification: () => {}
}

const NotificationContext = createContext(context)

export default NotificationContext
export { context }
